import { render, staticRenderFns } from "./lefttwo.vue?vue&type=template&id=d955f488&scoped=true&"
import script from "./lefttwo.vue?vue&type=script&lang=js&"
export * from "./lefttwo.vue?vue&type=script&lang=js&"
import style0 from "./lefttwo.vue?vue&type=style&index=0&id=d955f488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d955f488",
  null
  
)

export default component.exports